import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Icon, Button, Modal, Spin, message, Card } from 'antd';
import classNames from 'classnames'
import './category.css'
import axios from 'axios'
import { Odata_Url, Constants } from '../../../../../Constants/Constants'
import IntlMessages from '../../../../../util/IntlMessages';
import ScrollToTop from '../../../../../components/ScrollToTop'
import MenuSider from '../../../../../components/MenuSider'
import { Link } from 'react-router-dom'

const { TextArea } = Input;
const FormItem = Form.Item;

var initialcate = [];
const type_sub_cate = ['NA', 'Safe', 'Unsafe'];
const type_category_icon = ['', 'like', 'dislike', 'minus-circle'];
const type_category = ['Observe', 'Safe', 'Unsafe', 'Observed'];

const warning_safeunsafe = () => {
    message.warning('Please select safe or unsafe.');
};

const GroupBy = (data, property) => {
    return data.reduce((acc, obj) => {
        const key = obj[property]
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
}

class Category extends Component {
    constructor() {
        super();
        this.state = {
            category: [],
            sub_category: [],
            type_of_category: [],
            cate_name: 'Choose safe or unsafe',
            initial_cate: [],
            detail_cate: [],
            previewVisible: false,
            previewImage: '',
            fileList: [],
            loading: false
        }

        this.select_category = this.select_category.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }
    
    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentWillMount() {
        let mode = (this.props.location.state || {}).mode || 'create'
        this.setState({ mode: mode })
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        var category = this.props.location.state.category
        var jobtype = this.props.location.state.jobtype

        var cat = JSON.parse(window.localStorage.getItem('Category'))
        var sub_cat = JSON.parse(window.localStorage.getItem('Sub_Category'))
        var select_cat = JSON.parse(window.localStorage.getItem('Select_Category'))
        var detail_cat = JSON.parse(window.localStorage.getItem('Detail_Category'))

        var initial_detail_cat = []
        if (detail_cat !== null) {
            this.setState({
                detail_cate: detail_cat,
            })
            initial_detail_cat = detail_cat
        } else {
            cat.map((l, i) => {
                initial_detail_cat[i] = { category_ID: l.PKCategoryID, detail: null, rule: false, root_cause: null, near_miss: false }
                return null
            })
            this.setState({
                detail_cate: initial_detail_cat
            })
        }

        this.getJobtypeCategory().then(jobcat => {

            var scat = jobcat === undefined ? undefined : jobcat.filter(x => x.JobTypeId == jobtype.PKJobTypeID && category.filter(c => c.PKCategoryID === x.CatId).length > 0 && x.SubCatId !== null);
            var jcat = jobcat === undefined ? undefined : jobcat.filter(x => x.JobTypeId == jobtype.PKJobTypeID && x.SubCatId !== null);

            var sub_list = []
            sub_cat.map((l, i) => {
                var s = scat.find(x => x.SubCatId == l.PKSubCategoryID)
                if (s) {
                    sub_list.push(l)
                }
            })

            if (select_cat !== null) {
                initialcate = select_cat
                select_cat.map((l, i) => {
                    if (category.filter(x => x.PKCategoryID === l.cate_id).length > 0 && l.text === "Unsafe") {
                        initial_detail_cat.map(i => {
                            if (i.category_ID === l.cate_id)
                                i.rule = true
                        })
                    }
                    return null
                })
                this.setState({
                    detail_cate: initial_detail_cat
                })
            } else {
                jcat.map((l, i) => {
                    initialcate[i] = { cate_id: l.CatId, subcate_id: l.SubCatId, status: 0, text: type_sub_cate[0] }
                    return null
                })
            }

            this.setState({
                category: category,
                sub_category: sub_list,
                initial_cate: initialcate,
                jobtype: jobtype
            })
        })
    }

    async getJobtypeCategory() {
        this.setState({ loading: true });

        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let cat_res = await axios.get(
                    Odata_Url + 'OJobType_Category?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        const data = [];
                        response.data.value.forEach(function (element) {
                            data.push(element);
                        });
                        return data;
                    },
                        (error) => {
                            console.log(error);
                        });
                return cat_res;
            },
                (error) => {
                    console.log(error);
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
        this.setState({ loading: false });

        return res;
    }

    select_category(CategoryID, id) {
        var detail_cate2 = this.state.detail_cate
        var cat_id = CategoryID
        var cat_index = detail_cate2.findIndex(x => x.category_ID == cat_id)//category_ID
        let index = initialcate.findIndex(x => x.subcate_id == id && x.cate_id == cat_id)

        var check_sub_cate = true
        if (initialcate[index].status === 0) {
            initialcate[index].status = 1
            initialcate[index].text = type_sub_cate[1]
        } else {
            if (initialcate[index].status === 1) {
                initialcate[index].status = 2
                initialcate[index].text = type_sub_cate[2]
                detail_cate2[cat_index].rule = true
            } else {
                initialcate[index].status = 0
                initialcate[index].text = type_sub_cate[0]
                for (var i = 0; i < initialcate.length; i++) {
                    if (initialcate[i].cate_id === cat_id) {
                        if (initialcate[i].status === 2) {
                            check_sub_cate = false
                        }
                    }
                }
                if (check_sub_cate) {
                    detail_cate2[cat_index].rule = false
                }
            }
        }

        this.setState({
            initial_cate: initialcate,
            detail_cate: detail_cate2,
        }, () => {
            this.props.form.validateFields(['detail'], { force: true });
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                var category = this.state.category
                var detail_cat = this.state.detail_cate
                let cate = initialcate.filter(e => category.filter(x => x.PKCategoryID === e.cate_id && e.status !== 0).length > 0)
                let group = GroupBy(cate, 'cate_id')
                if (category.length !== Object.keys(group).length) {
                    warning_safeunsafe();
                    return
                }

                category.map(l => {
                    var detail_index = detail_cat.findIndex(x => x.category_ID == l.PKCategoryID)
                    detail_cat[detail_index].detail = values["detail_" + l.PKCategoryID]
                    this.cat_status(l.PKCategoryID, initialcate);
                })

                window.localStorage.setItem('Detail_Category', JSON.stringify(detail_cat))
                window.localStorage.setItem('Select_Category', JSON.stringify(initialcate))
                this.props.history.push({
                    pathname: "/newobservation_action",
                    state: { back: "Category", mode: this.state.mode }
                })
            }
        })
    }

    handleBack = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            //     if (!err) {
            var category = this.state.category
            var detail_cat = this.state.detail_cate

            // let cate = initialcate.filter(e => category.filter(x => x.PKCategoryID === e.cate_id && e.status !== 0).length > 0)
            // let group = GroupBy(cate, 'cate_id')
            // if (category.length !== Object.keys(group).length) {
            //     warning_safeunsafe();
            //     return
            // }

            category.map(l => {
                var detail_index = detail_cat.findIndex(x => x.category_ID == l.PKCategoryID)
                detail_cat[detail_index].detail = values["detail_" + l.PKCategoryID]
                this.cat_status(l.PKCategoryID, initialcate);
            })

            window.localStorage.setItem('Detail_Category', JSON.stringify(detail_cat))
            window.localStorage.setItem('Select_Category', JSON.stringify(initialcate))
            this.props.history.push({
                pathname: "/newobservation_checklist",
                state: { back: "Category", mode: this.state.mode }
            })
            //}
        })
    }

    cat_status(cat_id, initialcate) {
        var type_cate = JSON.parse(window.localStorage.getItem('type_of_category'))
        let cat_index = type_cate.findIndex(x => x.cat_id === cat_id)

        var count_safe = 0
        var count_unsafe = 0
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].cate_id === cat_id) {
                switch (initialcate[i].status) {
                    case 0:
                        continue;
                    case 1: count_safe++
                        continue;
                    case 2: count_unsafe++
                        break;
                    default:
                        continue;
                }
            }
        }
        if (count_unsafe !== 0) {
            type_cate[cat_index].type = type_category[2]
            type_cate[cat_index].icon = type_category_icon[2]
        } else {
            if (count_safe !== 0) {
                type_cate[cat_index].type = type_category[1]
                type_cate[cat_index].icon = type_category_icon[1]
            } else {
                type_cate[cat_index].type = type_category[3]
                type_cate[cat_index].icon = type_category_icon[3]
            }
        }
        var count_safe_unsafe = false
        for (var i = 0; i < initialcate.length; i++) {
            if (initialcate[i].text === "Unsafe") {
                count_safe_unsafe = true
                break;
            }
        }
        if (count_safe_unsafe) {
            window.localStorage.setItem("status_of_observed", 'unsafe');
        } else {
            window.localStorage.setItem("status_of_observed", 'safe');
        }
        window.localStorage.setItem("type_of_category", JSON.stringify(type_cate))
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const view = this.state.mode === 'view'
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        var { initial_cate, detail_cate, category } = this.state

        return (
            <div style={{ width: "100%" }}>
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">
                    <ScrollToTop />
                    <MenuSider title={<IntlMessages id="checklist.title" />} >

                        <Form onSubmit={this.handleSubmit} style={{ width: "100%" }} >
                            {
                                category.map(c => {
                                    var cate = initial_cate.filter(x => x.cate_id == c.PKCategoryID)
                                    var cat_index = detail_cate.findIndex(x => x.category_ID == c.PKCategoryID)
                                    return (
                                        <Card
                                            title={this.state.isEng ? c.Category_Name_EN : c.Category_Name}
                                            // extra={<a><Icon type="delete" onClick={() => this.props.onRemoveCategory(c.PKCategoryID, initialcate)} style={{ cursor: "pointer", color: 'red' }} /></a>}
                                            style={{ margin: '10px 0px 20px 0px' }}
                                        >
                                            {
                                                this.state.sub_category.map((l, i) => {
                                                    if (cate.filter(a => a.subcate_id === l.PKSubCategoryID).length > 0) {
                                                        let cat_index = cate.findIndex(x => x.subcate_id === l.PKSubCategoryID)
                                                        return (
                                                            <div id={'pop' + i} style={{ width: "100%", height: "48px", borderBottom: "1px solid #BFBFBF" }} key={'pop_sub_category' + i}>
                                                                <div className="col-s-1 col-t-1 col-d-1" style={{ display: "inline-block", height: "100%", textAlign: "center" }}>
                                                                    {l.SeqNo}
                                                                </div>
                                                                <div className="col-s-9 col-t-10 col-d-10" style={{ display: "inline-block", height: "100%", fontSize: "13px", marginTop: "5px", textAlign: "center" }}>
                                                                    {this.state.isEng ? l.SubCategory_Name_EN : l.SubCategory_Name}
                                                                </div>
                                                                <div className="col-s-2 col-t-1 col-d-1" style={{ display: "inline-block", height: "100%", paddingTop: "8px" }}>
                                                                    <div className={classNames({
                                                                        'sub-cate-default': 0 === cate[cat_index].status,
                                                                        'sub-cate-safe': 1 === cate[cat_index].status,
                                                                        'sub-cate-unsafe': 2 === cate[cat_index].status,
                                                                    })} style={{ outline: "none", borderRadius: "5px", width: "100%", height: "80%", textAlign: "center", fontSize: "16px", cursor: "pointer" }}
                                                                        onClick={() => view ? null : this.select_category(c.PKCategoryID, l.PKSubCategoryID)}
                                                                    >
                                                                        <label style={{ cursor: "pointer", paddingTop: "2px" }}>{cate[cat_index].text}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    return null
                                                })
                                            }
                                            <div style={{ width: "100", paddingTop: "10px", marginBottom: "15px" }}>
                                                < FormItem
                                                    label="Detail"
                                                    style={{ width: "100%", textAlign: "left" }}
                                                >
                                                    {
                                                        getFieldDecorator('detail_' + c.PKCategoryID, {
                                                            rules: [{
                                                                required: detail_cate[cat_index].rule,
                                                                message: 'Please input Detail!',
                                                            }],
                                                            initialValue: detail_cate[cat_index].detail
                                                        })(
                                                            <TextArea maxLength={2000}
                                                                placeholder="Autosize height with minimum and maximum number of lines"
                                                                readOnly={view}
                                                                autosize={{ minRows: 2, maxRows: 6 }}
                                                            />
                                                        )}
                                                </FormItem >
                                            </div>
                                        </Card>
                                    )
                                })
                            }
                            {
                                // !view && (
                                //     <FormItem style={{ width: "100%", textAlign: "center" }}>
                                //         <Button className="button-save-category" htmlType="submit" style={{ fontSize: "18px", width: "30%", height: "48px", borderRadius: "10px", outline: "none", backgroundColor: "rgb(0,152,139)", color: "white" }}>
                                //             Save
                                //         </Button>
                                //     </FormItem>
                                // )

                                <div className="footer" style={{ textAlign: "center", position: "fixed", height: "48px" }} >
                                    <Button onClick={this.handleBack} style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                        <Icon type="caret-left" style={{ position: "relative", right: "-4px" }} />
                                        <IntlMessages id='Back' />
                                        </Button>
                                    <Button htmlType="submit" style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                    <IntlMessages id='Next' /> <Icon type="caret-right" style={{ position: "relative", left: "-4px" }} />
                                    </Button>
                                </div>
                            }
                        </Form>
                    </MenuSider>
                </Spin>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_checklist: state.set_checklist
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        SET_IMAGE_CATEGORY: (values) => {
            dispatch({
                type: "SET_IMAGE_CATEGORY",
                upload: values
            })
        },
    }
}

const Newobservation_Checklist_Category = Form.create()(Category);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Checklist_Category)